var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "root", staticClass: "vks-session-params" }, [
    _c(
      "div",
      {
        staticClass: "vks-session-params-bubbles",
        attrs: { role: "group", "aria-label": "Search parameters" },
      },
      _vm._l(_vm.bubbles, function (bubble) {
        return _c(
          "button",
          {
            key: bubble.id,
            staticClass: "vks-session-param-bubble",
            class: { "is-open": _vm.openParam === bubble.id },
            attrs: {
              type: "button",
              "aria-expanded": _vm.openParam === bubble.id ? "true" : "false",
              "aria-controls": _vm.openParam === bubble.id ? _vm.panelId : null,
              "aria-label": `Change ${bubble.title}: ${bubble.value}`,
              title: `Change ${bubble.title}`,
            },
            on: {
              click: function ($event) {
                return _vm.toggleParam(bubble.id)
              },
            },
          },
          [
            _c("span", { staticClass: "vks-session-param-bubble-value" }, [
              _vm._v(_vm._s(bubble.value)),
            ]),
          ]
        )
      }),
      0
    ),
    _vm.openParam
      ? _c(
          "div",
          {
            staticClass: "vks-session-param-panel",
            attrs: {
              id: _vm.panelId,
              role: "dialog",
              "aria-label": _vm.activePanelTitle,
            },
          },
          [
            _c("header", { staticClass: "vks-session-param-panel-head" }, [
              _c("h3", { staticClass: "vks-session-param-panel-title" }, [
                _vm._v(_vm._s(_vm.activePanelTitle)),
              ]),
              _c(
                "button",
                {
                  staticClass: "vks-session-param-panel-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.closePanel },
                },
                [_vm._v(" × ")]
              ),
            ]),
            _vm.openParam === "project"
              ? _c(
                  "div",
                  { staticClass: "vks-session-param-panel-body" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "vks-session-param-label",
                        attrs: { for: _vm.projectSelectId },
                      },
                      [_vm._v("Project")]
                    ),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.draftProjectId,
                            expression: "draftProjectId",
                          },
                        ],
                        staticClass: "vks-session-param-select",
                        attrs: { id: _vm.projectSelectId },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.draftProjectId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.projectOptions, function (project) {
                        return _c(
                          "option",
                          {
                            key: project.id || "default",
                            domProps: { value: project.id },
                          },
                          [_vm._v(" " + _vm._s(project.label) + " ")]
                        )
                      }),
                      0
                    ),
                    _vm.draftUsesTokenSearch
                      ? [
                          _c(
                            "label",
                            {
                              staticClass: "vks-session-param-label",
                              attrs: { for: _vm.tokenInputId },
                            },
                            [_vm._v(" Token ")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.draftToken,
                                expression: "draftToken",
                              },
                            ],
                            staticClass: "vks-session-param-input",
                            attrs: {
                              id: _vm.tokenInputId,
                              type: "text",
                              autocomplete: "off",
                              spellcheck: "false",
                              placeholder: "GWAS-CE access token",
                            },
                            domProps: { value: _vm.draftToken },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.draftToken = $event.target.value
                              },
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm.openParam === "phenotype"
              ? _c("div", { staticClass: "vks-session-param-panel-body" }, [
                  _vm.panelPhenotypeBubbles.length
                    ? _c(
                        "div",
                        {
                          staticClass: "vks-session-param-phenotype-bubbles",
                          attrs: {
                            role: "list",
                            "aria-label": "Active phenotypes",
                          },
                        },
                        _vm._l(_vm.panelPhenotypeBubbles, function (bubble) {
                          return _c(
                            "span",
                            {
                              key: bubble.name,
                              staticClass: "vks-session-param-phenotype-bubble",
                              attrs: { role: "listitem" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "vks-session-param-phenotype-bubble-label",
                                },
                                [_vm._v(" " + _vm._s(bubble.label) + " ")]
                              ),
                              _vm.canRemovePanelPhenotype
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "vks-session-param-phenotype-bubble-remove",
                                      attrs: {
                                        type: "button",
                                        "aria-label": `Remove ${bubble.label}`,
                                        title: `Remove ${bubble.label}`,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onRemovePhenotypeBubble(
                                            bubble
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" × ")]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c(
                    "label",
                    {
                      staticClass: "vks-session-param-label",
                      attrs: { for: _vm.phenotypeInputId },
                    },
                    [_vm._v(" Phenotype ")]
                  ),
                  _c("div", { staticClass: "vks-session-param-typeahead" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phenotypeQuery,
                          expression: "phenotypeQuery",
                        },
                      ],
                      staticClass: "vks-session-param-input",
                      attrs: {
                        id: _vm.phenotypeInputId,
                        type: "text",
                        autocomplete: "off",
                        placeholder: "Search phenotype",
                      },
                      domProps: { value: _vm.phenotypeQuery },
                      on: {
                        focus: _vm.onPhenotypeFocus,
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.phenotypeQuery = $event.target.value
                          },
                          _vm.onPhenotypeInput,
                        ],
                      },
                    }),
                    _vm.phenotypeListOpen && _vm.phenotypeSuggestions.length
                      ? _c(
                          "div",
                          {
                            staticClass: "vks-session-param-suggestions",
                            attrs: { role: "listbox" },
                          },
                          _vm._l(
                            _vm.phenotypeSuggestions,
                            function (phenotype) {
                              return _c(
                                "button",
                                {
                                  key: phenotype.name,
                                  staticClass: "vks-session-param-suggestion",
                                  attrs: { type: "button", role: "option" },
                                  on: {
                                    mousedown: function ($event) {
                                      $event.preventDefault()
                                      return _vm.selectPhenotype(phenotype)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "vks-session-param-suggestion-label",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.phenotypeSuggestionLabel(
                                              phenotype
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _vm.phenotypeSuggestionMeta(phenotype)
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "vks-session-param-suggestion-meta",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.phenotypeSuggestionMeta(
                                                  phenotype
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "label",
                    {
                      staticClass: "vks-session-param-checkbox",
                      attrs: { for: _vm.addPhenotypeId },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.addPhenotype,
                            expression: "addPhenotype",
                          },
                        ],
                        attrs: { id: _vm.addPhenotypeId, type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.addPhenotype)
                            ? _vm._i(_vm.addPhenotype, null) > -1
                            : _vm.addPhenotype,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.addPhenotype,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.addPhenotype = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.addPhenotype = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.addPhenotype = $$c
                            }
                          },
                        },
                      }),
                      _c("span", [_vm._v("Add phenotype")]),
                    ]
                  ),
                ])
              : _vm.openParam === "ancestry"
              ? _c("div", { staticClass: "vks-session-param-panel-body" }, [
                  _c(
                    "label",
                    {
                      staticClass: "vks-session-param-label",
                      attrs: { for: _vm.ancestrySelectId },
                    },
                    [_vm._v(" Ancestry ")]
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.draftAncestry,
                          expression: "draftAncestry",
                        },
                      ],
                      staticClass: "vks-session-param-select",
                      attrs: { id: _vm.ancestrySelectId },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.draftAncestry = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.ancestryOptions, function (ancestry) {
                      return _c(
                        "option",
                        { key: ancestry, domProps: { value: ancestry } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.ancestryLabel(ancestry)) + " "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm.openParam === "region"
              ? _c("div", { staticClass: "vks-session-param-panel-body" }, [
                  _c(
                    "label",
                    {
                      staticClass: "vks-session-param-label",
                      attrs: { for: _vm.locusInputId },
                    },
                    [_vm._v(" Gene, variant, or region ")]
                  ),
                  _c("div", { staticClass: "vks-session-param-typeahead" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.locusQuery,
                          expression: "locusQuery",
                        },
                      ],
                      staticClass: "vks-session-param-input",
                      attrs: {
                        id: _vm.locusInputId,
                        type: "text",
                        autocomplete: "off",
                        placeholder:
                          "e.g. FTO, rs7903146, 16:53700000-54200000",
                      },
                      domProps: { value: _vm.locusQuery },
                      on: {
                        focus: _vm.onLocusFocus,
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.locusQuery = $event.target.value
                          },
                          _vm.onLocusInput,
                        ],
                      },
                    }),
                    _vm.geneListOpen && _vm.geneSuggestions.length
                      ? _c(
                          "div",
                          {
                            staticClass: "vks-session-param-suggestions",
                            attrs: { role: "listbox" },
                          },
                          _vm._l(_vm.geneSuggestions, function (gene) {
                            return _c(
                              "button",
                              {
                                key: gene,
                                staticClass: "vks-session-param-suggestion",
                                attrs: { type: "button", role: "option" },
                                on: {
                                  mousedown: function ($event) {
                                    $event.preventDefault()
                                    return _vm.selectGene(gene)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(gene) + " ")]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "label",
                    {
                      staticClass: "vks-session-param-label",
                      attrs: { for: _vm.expandSelectId },
                    },
                    [_vm._v(" Region expand ")]
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.draftExpandBp,
                          expression: "draftExpandBp",
                        },
                      ],
                      staticClass: "vks-session-param-select",
                      attrs: { id: _vm.expandSelectId },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.draftExpandBp = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.regionExpandOptions, function (option) {
                      return _c(
                        "option",
                        {
                          key: String(option.value),
                          domProps: { value: option.value },
                        },
                        [_vm._v(" " + _vm._s(option.label) + " ")]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm.errorMessage
              ? _c(
                  "p",
                  {
                    staticClass: "vks-session-param-error",
                    attrs: { role: "alert" },
                  },
                  [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
                )
              : _vm._e(),
            _c("footer", { staticClass: "vks-session-param-panel-footer" }, [
              _c(
                "button",
                {
                  staticClass: "vks-session-param-cancel",
                  attrs: { type: "button" },
                  on: { click: _vm.closePanel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "button",
                {
                  staticClass: "vks-session-param-apply",
                  attrs: { type: "button", disabled: _vm.applying },
                  on: { click: _vm.onApply },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.applying ? "Updating…" : "Apply & search") +
                      " "
                  ),
                ]
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }